import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import LoadingPage from "../error_page/loadingPage";

function isAdmin(user) {
    return user?.role?.toLowerCase() === "admin";
}

/** Blocks non-admins from admin UI. Use as layout (`<Route element={<ProtectedAdminRoute />}>`) or wrapper. */
export function ProtectedAdminRoute({ children }) {
    const { user, token, loading } = useAuth();

    if (loading) {
        return <LoadingPage />;
    }

    if (!user || !token) {
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin(user)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children ?? <Outlet />;
}
